// Loaders
import { BaseWorkerLoader } from "../../base/loaders/BaseWorkerLoader";
/**
 * Loader class for loading workers in the metaOS app
 */
export class MetaOSAppWorkerLoader extends BaseWorkerLoader {
}
